import { useRegisterContext } from "../Contexts/RegisterContext";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";
import React from "react";

function MemberConsentModal({ isOpen, onClose }) {
  const { setMemberConsentChecked, setShowMemberConsentModal } =
    useRegisterContext();

  const handleClose = () => {
    setMemberConsentChecked(true);
    setShowMemberConsentModal(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className=" overflow-y-scroll sm:overflow-y-hidden"
    >
      <div className="flex flex-col min-h-screen max-w-screen sm:bg-[#E7EEFA] items-start sm:items-center">
        <div className="w-full sm:w-148 flex-grow">
          <div className="sm:w-full bg-white rounded-xl sm:mt-14">
            <div className="w-full grid grid-cols-1 divide-y">
              <div className="m-4">
                <div className="grid justify-items-end">
                  <CloseIcon
                    className="cursor-pointer absolute"
                    onClick={onClose}
                    sx={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </div>
                <div className=" font-bold text-center ">Member Consent</div>
              </div>

              <div>
                <div className="sm:h-96 overflow-y-scroll">
                  <div className="w-full p-4">
                    <div className="text-xs text-justify">
                      In reference to my and/or my dependent/s’ healthcare plan
                      procured by the Company, I hereby certify that I and my
                      dependent/s have read and understood the Summary of
                      Coverage and Benefits of the Service Agreement executed by
                      Maxicare Healthcare Corporation (“Maxicare”) and the
                      Company including all procedures, benefits, exclusions,
                      limitations, and conditions contained therein, and agree
                      to be bound thereby. Furthermore, by availing the services
                      of Maxicare, I and my dependent/s acknowledge and agree to
                      abide by all the membership terms and conditions published
                      via Maxicare website at{" "}
                      <a
                        href="https://maxicare.ph/MaxicareeHealth"
                        target="_blank"
                        rel="noreferrer"
                        className="text-[#0947AB] font-semibold"
                      >
                        https://maxicare.ph/MaxicareeHealth
                      </a>
                      {/* */}.
                    </div>

                    <div className="mt-2">
                      <div className="text-xs text-justify">
                        In executing this document and in affixing my signature
                        hereto, I confirm that:
                      </div>

                      <div className=" mt-2 text-xs text-justify ml-4">
                        <span className="font-bold">1. </span> I agree and
                        understand that in the course of providing services to
                        me or my dependents, Maxicare shall engage the services
                        of, and/or interact with, other third parties, such as,
                        but not limited to the Department of Health, Philippine
                        Health Insurance Corporation, the national and local
                        government and other relevant government agencies who
                        may require information relative to my health condition
                        (past or present), Maxicare’s company its parent
                        company, affiliated companies, subsidiaries, financial
                        advisors, affiliated third parties or
                        independent/non-affiliated third parties and service
                        providers, whether local or foreign (collectively
                        referred to as "{/* */}
                        <span className="font-bold">Representatives</span>").
                      </div>

                      <div className="mt-2">
                        <div className="text-xs text-justify ml-4">
                          <span className="font-bold">2. </span> I and my
                          dependent/s agree and understand that, at the time of
                          the effectivity of the Agreement and the effectivity
                          of coverage of his membership, Maxicare has obtained
                          from the Member and his Dependents the required
                          consents pursuant to Republic Act No. 10173, otherwise
                          known as the Data Privacy Act of 2012, including its
                          Implementing Rules and Regulations and other issuances
                          of the National Privacy Commission (collectively, the
                          “<span className="font-bold">Data Privacy Laws</span>
                          {/* */}
                          ”) authorizing Maxicare and its Representatives, the
                          Company and any of their stockholders, directors,
                          officers, employees, agents, brokers, or
                          representatives (collectively, the “authorized
                          representatives”) to:
                        </div>

                        <div className="mt-2 text-xs text-justify ml-10">
                          <span className="font-bold">a. </span> Obtain,
                          examine, process, collect, record, organize, store,
                          update or modify, retrieve, consult, use, consolidate,
                          block, erase, destroy or do any operation or set of
                          operations (collectively “process” / “processing”) the
                          Member’s and his Dependent/s’ personal information,
                          including sensitive personal information and
                          privileged information, medical records, or any other
                          information or material, i.e., picture, video and
                          voice recording, fingerprints, CCTV and etc.,
                          (collectively “personal data”) relative to the Member
                          and his Dependents’ application and membership with
                          Maxicare, availment of the Services, hospitalization,
                          consultation, and treatment or any medical advice in
                          connection with the benefit/claim availed under the
                          Agreement, as may be deemed necessary by Maxicare.
                          Except as otherwise stated in this T&Cs, any personal
                          data obtained relative to the authority herein given
                          shall be kept strictly confidential. The extent of the
                          processing of the Personal Data shall be limited to
                          what is necessary, appropriate or incidental to the
                          performance of the Services contemplated in the
                          Agreement.
                        </div>

                        <div className="mt-2 text-xs text-justify ml-10">
                          <span className="font-bold">b. </span> Process and
                          disclose such Personal Data to Maxicare and its
                          Representatives, the Company, and their authorized
                          representatives as well as relevant government
                          agencies in compliance with the Republic Act No. 11223
                          otherwise known as the “Universal Health Care Act”,
                          its Implementing Rules and Regulations, Republic Act
                          No. 11332 otherwise known as the “Mandatory Reporting
                          of Notifiable Diseases and Health Events of Public
                          Health Concern Act” and other relevant issuances of
                          the Department of Health and/or Philippine Health
                          Insurance Corporation, and any amendments to such
                          laws, rules, regulations and issuances for any
                          legitimate business purpose as Maxicare may deem
                          appropriate, including but not limited to outsourced
                          processing of Maxicare transactions, billing of co-pay
                          arrangements or Administrative Services Only (ASO),
                          lifestyle and rewards partners/providers, profiling or
                          historical statistical analysis, providing advice or
                          information which Maxicare,its Representatives and
                          their authorized representatives believe may be of
                          interest to the User/Member or the Company, to
                          effectively administer or manage my account, enhance
                          customer services, or to communicate with me for any
                          marketing purposes.
                        </div>

                        <div className="mt-2 text-xs text-justify ml-4">
                          For clarity, processing would include both manual and
                          automated handling, storage and transfer of personal
                          data using various means and methods whether physical
                          or electronic (via information and communications
                          systems employed by Maxicare and its Representatives).
                        </div>

                        <div className="mt-2">
                          <div className="text-xs text-justify ml-4">
                            <span className="font-bold">3. </span> I have been
                            duly authorized by my dependent/s to sign and
                            execute any and all documents and make
                            representations for and in his/their behalf as if
                            the same were personally done by him/them.
                          </div>
                        </div>

                        <div className="mt-2">
                          <div className="text-xs text-justify ml-4">
                            <span className="font-bold">4. </span> I hereby
                            warrant that we understand our rights and
                            obligations pursuant to the Data Privacy Act
                            Mandatory Reporting of Notifiable Diseases and
                            Health Events of Public Health Concern Act, and
                            Universal Healthcare Act, their respective
                            implementing rules and regulations, and related
                            issuances, and its implementing rules and
                            regulations. I and my dependents understand that we
                            retain the right to: be informed, to object, to
                            access, to complain, to rectify, to request for
                            filtering of certain information and to
                            corresponding damages in case of violation of our
                            rights within the corresponding limitations as set
                            forth in the pertinent laws.
                          </div>
                        </div>

                        <div className="mt-2">
                          <div className="text-xs text-justify ml-4">
                            <span className="font-bold">5. </span> I and my
                            dependents hereby represent that, in order to
                            provide the services contemplated in the Agreement,
                            the authorities herein provided shall be valid and
                            existing during the term of the Agreement, including
                            any extensions thereof, and until necessary for the
                            establishment, exercise or defense of any claims
                            arising from the said Agreement.
                          </div>
                        </div>

                        <div className="mt-2">
                          <div className="text-xs text-justify ml-4">
                            <span className="font-bold">6. </span> I and my
                            dependents hereby agree to hold Maxicare and its
                            Representatives free and harmless from and against
                            any and all suits or claims, actions, or
                            proceedings, damages, costs and expenses, including
                            attorney’s fees, which may be filed, charged or
                            adjudged against Maxicare or any of its directors,
                            stockholders, officers, employees, agents, or
                            Representatives in connection with or arising from
                            the use, processing and disclosure by Maxicare or
                            its Representatives of the aforementioned
                            information pursuant to Maxicare reliance on my and
                            my dependent’s representation and warranty that
                            Maxicare, the Company, and their representatives
                            have the authority to examine, use, process, store,
                            share, or disclose, as the case may be, said
                            information for the above-mentioned purposes.
                          </div>
                        </div>

                        <div className="mt-2">
                          <div className="text-xs text-justify ml-4">
                            For any general membership inquiries and concerns
                            (dependent enrollments, benefits among others), you
                            may address them to{" "}
                            <a
                              href="mailto:customercare@maxicare.com.ph"
                              target="_blank"
                              rel="noreferrer"
                              className="text-[#0947AB] font-semibold"
                            >
                              customercare@maxicare.com.ph
                            </a>
                            {/* */}.
                          </div>
                        </div>

                        <div className="mt-2">
                          <div className="text-xs text-justify ml-4">
                            Maxicare reserves the right to amend the Membership
                            Terms and Conditions at any time without need of
                            prior notice or approval, and any queries related to
                            the terms and conditions may be addressed to{" "}
                            <a
                              href="mailto:dpo@maxicare.com.ph"
                              target="_blank"
                              rel="noreferrer"
                              className="text-[#0947AB] font-semibold"
                            >
                              dpo@maxicare.com.ph
                            </a>
                            {/* */}.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-4">
                  <Button className="w-full text-white" onClick={handleClose}>
                    I agree
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

MemberConsentModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};
export default MemberConsentModal;
